import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxImageCompressService } from 'ngx-image-compress';
import { GalleryItems } from 'src/app/helpers';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { SharedService } from 'src/app/services/shared/shared.service';

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss'],
})
export class GalleryModalComponent implements OnInit {
  public galleryData: boolean = false;
  public submitted: boolean = false;
  public galleryForm: UntypedFormGroup = null;
  public file: File = null;

  @ViewChild(FormGroupDirective, { static: false }) gallery: FormGroupDirective;

  constructor(
    public formBuilder: UntypedFormBuilder,
    public modalRef: BsModalRef,
    public sharedService: SharedService,
    public galleryService: GalleryService,
    private imageCompress: NgxImageCompressService
  ) {
    this.galleryForm = this.formBuilder.group({
      part_name: ['', [Validators.required]],
      part_name_arabic: ['', [Validators.required]],
      part: [''],
    });
  }

  ngOnInit(): void {}

  get formData() {
    return this.galleryForm.controls;
  }

  fileGetter(evt: Event) {
    let target: any = evt.target;
    let fileObj: File = target['files'][0];
    let reader: FileReader = new FileReader();
    let fileFormatCheck: boolean =
      fileObj.type == 'image/png' ||
      fileObj.type == 'image/jpg' ||
      fileObj.type == 'image/jpeg' ||
      fileObj.type == 'image/webp';

    if (fileFormatCheck) {
      reader.readAsDataURL(fileObj);
      reader.onload = (ev) => {
        let base64: string = ev.target.result as string;
        this.imageCompression(base64, fileObj.name);
      };
    } else return false;
  }

  imageCompression(base64: string, fileName: string) {

    this.imageCompress.compressFile(base64, -1, 60, 50).then((res) => {

      const imageBlob = this.sharedService.dataURItoBlob(res.split(',')[1]);
      this.file = new File([imageBlob], fileName, { type: 'image/jpeg' });
    });
  }

  saveGallery() {
    const formData: FormData = new FormData();
    this.submitted = true;

    if (this.galleryForm.invalid) {
      return false;
    } else {
      if (this.file) {
        formData.set('vehicle_id', this.sharedService.getVehicleId);
        formData.set('part_id', '');
        formData.set('part_name', this.galleryForm.get('part_name').value);
        formData.set(
          'part_name_arabic',
          this.galleryForm.get('part_name_arabic').value
        );
        formData.set('vehicle_gallery_data', this.file);

        this.galleryService.setGallery(formData).subscribe(
          (res) => {
            this.sharedService.setGallerySubmission = res['success'];
          },
          (error) => {}
        );
        this.modalRef.hide();
      }
    }
  }
}
